export enum GenMessageType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error'
}